// extracted by mini-css-extract-plugin
export var container = "ClientGrid-module--container--ea552";
export var description = "ClientGrid-module--description--b823b";
export var grid = "ClientGrid-module--grid--57bd3";
export var hoverText = "ClientGrid-module--hoverText--34e72";
export var logo = "ClientGrid-module--logo--857a5";
export var paragraph = "ClientGrid-module--paragraph--4ba70";
export var paragraphSm = "ClientGrid-module--paragraph-sm--61644";
export var paragraphXs = "ClientGrid-module--paragraph-xs--66d99";
export var tieredCols = "ClientGrid-module--tieredCols--13d9b";
export var tieredLayout = "ClientGrid-module--tieredLayout--abee8";
export var titleH1 = "ClientGrid-module--title-h1--a11ae";
export var titleH1Alt = "ClientGrid-module--title-h1--alt--a863e";
export var titleH2 = "ClientGrid-module--title-h2--9553b";
export var titleH2Alt = "ClientGrid-module--title-h2--alt--f16b2";
export var titleH3 = "ClientGrid-module--title-h3--1d6f2";
export var titleH3Alt = "ClientGrid-module--title-h3--alt--3675c";
export var titleH4 = "ClientGrid-module--title-h4--ae86d";
export var titleH4Alt = "ClientGrid-module--title-h4--alt--9efe6";
export var titleH5 = "ClientGrid-module--title-h5--db2a5";